// T570a (1 Nov 2026, Natanel's "Sign out"): asked in the brain's chat, the agent's `sign_out` card is
// applied at once and the tab that asked signs itself out, after its answer has shown. Only this
// tab's own answer counts, never a card read back from the chat: a chat is shared, and a colleague
// with it open must not be signed out by someone else's ask (services/bff/src/actions.ts `sign_out`).

/** The pause between the answer showing and the sign-in page, so "signed out" is read first. */
export const SIGN_OUT_AFTER_MS = 2000;

/** Whether this answer applied a `sign_out`: this browser's, or every browser's, this one among them. */
export function answerSignsOut(
  actions: readonly { status: string; steps: readonly { tool: string }[] }[],
): boolean {
  return actions.some(
    (card) => card.status === 'applied' && card.steps.some((step) => step.tool === 'sign_out'),
  );
}

let signOutHere: (() => void) | null = null;

/** VeraPanel hands over Clerk's sign-out for this tab; the return takes it back. */
export function onSignOutHere(run: () => void): () => void {
  signOutHere = run;
  return () => {
    if (signOutHere === run) signOutHere = null;
  };
}

/**
 * T570a review round 1 (R9): a card this tab itself confirmed (its Confirm), as
 * opposed to one read back from the chat. A `sign_out` the ask could not apply at once and
 * confirmed later here signs this tab out too, as its done line says.
 */
export function confirmedHere(card: { status: string; steps: readonly { tool: string }[] }): void {
  if (!answerSignsOut([card])) return;
  // Taken now (fix round 1, 5): the panel closing in the pause takes the handler back.
  const run = signOutHere;
  setTimeout(() => (run ?? signOutHere)?.(), SIGN_OUT_AFTER_MS);
}
